import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const FilterReversePyramid = ({ size = 24, color = '#000', ...props }) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <G clipPath="url(#clip0_95_3362)">
      <Path
        d="M14.1667 9.1665H5.83333C5.61232 9.1665 5.40036 9.2543 5.24408 9.41058C5.0878 9.56686 5 9.77882 5 9.99984C5 10.2209 5.0878 10.4328 5.24408 10.5891C5.40036 10.7454 5.61232 10.8332 5.83333 10.8332H14.1667C14.3877 10.8332 14.5996 10.7454 14.7559 10.5891C14.9122 10.4328 15 10.2209 15 9.99984C15 9.77882 14.9122 9.56686 14.7559 9.41058C14.5996 9.2543 14.3877 9.1665 14.1667 9.1665ZM11.6667 14.1665H8.33333C8.11232 14.1665 7.90036 14.2543 7.74408 14.4106C7.5878 14.5669 7.5 14.7788 7.5 14.9998C7.5 15.2209 7.5878 15.4328 7.74408 15.5891C7.90036 15.7454 8.11232 15.8332 8.33333 15.8332H11.6667C11.8877 15.8332 12.0996 15.7454 12.2559 15.5891C12.4122 15.4328 12.5 15.2209 12.5 14.9998C12.5 14.7788 12.4122 14.5669 12.2559 14.4106C12.0996 14.2543 11.8877 14.1665 11.6667 14.1665ZM16.6667 4.1665H3.33333C3.11232 4.1665 2.90036 4.2543 2.74408 4.41058C2.5878 4.56686 2.5 4.77882 2.5 4.99984C2.5 5.22085 2.5878 5.43281 2.74408 5.58909C2.90036 5.74537 3.11232 5.83317 3.33333 5.83317H16.6667C16.8877 5.83317 17.0996 5.74537 17.2559 5.58909C17.4122 5.43281 17.5 5.22085 17.5 4.99984C17.5 4.77882 17.4122 4.56686 17.2559 4.41058C17.0996 4.2543 16.8877 4.1665 16.6667 4.1665Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_95_3362">
        <Rect width={20} height={20} fill={color} />
      </ClipPath>
    </Defs>
  </Svg>
)
export default FilterReversePyramid
